import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import ClientPassengerInterface from '../../interfaces/client/Passenger'

import {
  selectAllPassengersForDeletion,
  deselectAllPassengersForDeletion,
} from '../../actions/deletePassengers'

import EditBookingFormRowHeader from '../../components/EditBookingFormRowHeader'

interface EditBookingFormRowHeaderPropsInterface {
  isTOFlight: boolean
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  props: EditBookingFormRowHeaderPropsInterface
) => {
  const allPassengerIds = state.passengers.allIds
    .map((passengerId: string) => state.passengers.byId[passengerId])
    .reduce((passengerIds: string[], passenger: ClientPassengerInterface) => {
      const allPassengerIds = [...passengerIds, passenger.id]

      if (passenger.infant && passenger.infant.id) {
        allPassengerIds.push(passenger.infant.id)
      }

      return allPassengerIds
    }, [])
    .filter((passengerId: string) => passengerId)

  return {
    allPassengerIds,
    showTravelClass: props.isTOFlight,
    isDeletePassengersEnabled: state.deletePassengers.isDeletePassengersEnabled,
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  selectAllPassengersForDeletion: (passengerIds: string[]) => {
    dispatch(selectAllPassengersForDeletion(passengerIds))
  },
  deselectAllPassengersForDeletion: () => {
    dispatch(deselectAllPassengersForDeletion())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditBookingFormRowHeader)
